var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeartRate = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 7.333h-2.627a.52.52 0 00-.14 0h-.113a.875.875 0 00-.1.067 1.112 1.112 0 00-.107.08.654.654 0 00-.06.087.869.869 0 00-.08.133l-1.066 2.94-2.78-7.533a.667.667 0 00-1.254 0l-1.54 4.226H2a.667.667 0 000 1.334h2.867a.574.574 0 00.106-.067c.037-.024.073-.051.107-.08l.06-.087a.667.667 0 00.08-.133L6.3 5.28l2.773 7.613a.667.667 0 001.254 0l1.533-4.226H14a.667.667 0 100-1.334z",
  fill: "#44494D"
})));
export default __webpack_public_path__ + "static/heartRate.[git-hash].svg";
export { SvgHeartRate as ReactComponent };